import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '@app/shared';
import { DisplayBadgeModule } from '@app/shared/display-badge/display-badge.module';
import { JobLoadingModule } from '@app/shared/job-loading/job-loading.module';
import { JobPropertiesModule } from '@app/shared/job-properties/job-properties.module';
import { FeaturedJobsComponent } from './featured-jobs.component';

@NgModule({
  declarations: [FeaturedJobsComponent],
  imports: [
    CommonModule,
    DisplayBadgeModule,
    JobLoadingModule,
    JobPropertiesModule,
    RouterModule,
    SharedModule,
  ],
  exports: [FeaturedJobsComponent],
})
export class FeaturedJobsModule {}
